import { SessionAccess, WebinarTimezone } from "./models";

export type SessionSaveDto = {
  id?: string;
  title: string;
  oneLiner: string;
  fullDesc: string;
  takeaways: string[];
  topicId: string;
  hostId: string;
  date: string;
  time: string;
  timezone: WebinarTimezone;
  startAt: string;
  mins: number;
  access: SessionAccess;
  cohorts: string[];
  lang: string;
  format: string;
  provider: string;
  joinUrl: string;
  recurrence: string;
  recEnd?: string;
  status: "draft" | "scheduled";
  /** True when editing a scheduled session and start time changed. */
  isRescheduled?: boolean;
};

export type SessionRemoveDto = {
  id: string;
  kind: "delete_draft" | "cancel_scheduled";
  reason?: string;
  note?: string;
};

export type SessionReinstateDto = {
  id: string;
};

/** Create sends a full body; update may send only changed fields (+ id). */
export type HostSaveDto = {
  id?: string;
  name?: string;
  role?: string;
  bio?: string;
  creds?: string[];
  /** Empty string clears photo on update when included. */
  photo?: string;
  phoneNumber?: string;
};

export type TopicSaveDto = {
  id?: string;
  name: string;
  slug?: string;
  color?: string;
};

export type ListSessionsQuery = {
  status?: string;
  /** Search title / host / topic — sent as `search` query param. */
  q?: string;
  page?: number;
  /** Page size — sent as `limit` query param. */
  limit?: number;
};

export type WebinarServiceErrorCode =
  | "NOT_FOUND"
  | "INVALID_TRANSITION"
  | "VALIDATION"
  | "CONFLICT"
  | "UNAVAILABLE";

export class WebinarServiceError extends Error {
  code: WebinarServiceErrorCode;

  constructor(code: WebinarServiceErrorCode, message: string) {
    super(message);
    this.name = "WebinarServiceError";
    this.code = code;
  }
}
